import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const PortfolioSingle = () => {

  // Get Portfolio details passed via router state
  const location = useLocation();
  const portfolio = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={portfolio.title} page={"Portfolio Single"} />

      <section className='portfolio-single page-single'>

        <div className='portfolio-info page-info'>

          {/* Portfolio Image */}
          <div className='image'>
            <img src={portfolio.image} alt={portfolio.title} />
          </div>

          <div className='content'>

            {/* Portfolio Title */}
            <h3 className='main-heading'>{portfolio.title}</h3>

            {/* Portfolio Description */}
            {portfolio.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Portfolio Image Gallery */}
            <Lightbox images={portfolio.gallery} />

            {/* Portfolio Highlights */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Portfolio Highlights:</h3>
              <p>A glimpse into the standout moments and special touches delivered through the {portfolio.title} project:</p>

              {/* Highlights List */}
              <ul>
                {portfolio.highlights.map((highlight, index) => {
                  return <li key={index}> <div className='icon'><FaCaretRight  /></div> {highlight}</li>
                })}
              </ul>

            </div>

            {/* Challenges and Solutions */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Challenges and Solutions:</h3>
              <p>Key lessons learned and smart solutions applied during the planning and execution of the {portfolio.title} event:</p>

              {/* List Points */}
              <ul>
                {portfolio.solutions.map((solution, index) => {
                  return <li key={index}> <div className='icon'><FaCheck  /></div> {solution}</li>
                })}
              </ul>

            </div>

            {/* Key Benefits */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Key Benefits:</h3>
              <p>Notable advantages and guest experiences that made the {portfolio.title} event truly memorable:</p>

              {/* Benefits List */}
              <ul>
                {portfolio.benefits.map((benefit, index) => {
                  return <li key={index}> <div className='icon'><FaCircleNotch /></div> {benefit}</li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Portfolio details */}
        <PageSidebar
          heading={'Portfolio'}
          details={portfolio.details}
        />

      </section>

    </> 
  );
}

export default PortfolioSingle;